$('.product-tasks-image-slider').slick({
    infinite: true,
    speed: 500,
    fade: true,
    arrows: false,
    cssEase: 'linear',
    asNavFor: '.product-tasks-text-slider',
});
$('.product-tasks-text-slider').slick({
    infinite: true,
    speed: 500,
    fade: true,
    arrows: true,
    appendArrows: '.product-tasks-right-bot',
    prevArrow: '<div class="product-tasks-slider-nav product-tasks-slider-prev">\n' +
        '                            <svg width="23" height="6" viewBox="0 0 23 6" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '                                <path d="M23 1L3 1L7.70588 5" stroke="white" stroke-width="1.5"/>\n' +
        '                            </svg>\n' +
        '                        </div>',
    nextArrow: '' +
        ' <div class="product-tasks-slider-nav product-tasks-slider-next">\n' +
        '                            <svg width="23" height="6" viewBox="0 0 23 6" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '                                <path d="M0 5H20L15.2941 1" stroke="white" stroke-width="1.5"/>\n' +
        '                            </svg>\n' +
        '                        </div>',
    cssEase: 'linear',
    adaptiveHeight: true,
    asNavFor: '.product-tasks-image-slider',
});

const slider = $('.product-tasks-text-slider')

function formattedNumber(value){
    if(value < 10){
        return '0' + value.toString()
    } else {
        return value
    }
}
function countAllSlides(){
    let totalSlides = slider.slick('getSlick').slideCount;
    $('.product-tasks-slider-counter-amount').text(formattedNumber(totalSlides))
}
function detectCurrentSlide(){
    let activeSlideIndex = slider.slick('slickCurrentSlide');
    $('.product-tasks-slider-counter-current').text(formattedNumber(activeSlideIndex + 1))
}
slider.on('afterChange', function(){
    detectCurrentSlide()
});

detectCurrentSlide()
countAllSlides()
